export default {"src":"/_next/static/media/openwebui-app-service.ed0a7464.svg","height":1080,"width":1920,"blurWidth":0,"blurHeight":0};